import { JSX, JSXElement } from 'solid-js';
import { PanelLayout } from '@tcweb/connect-ui';

export interface PanelLayoutWithHeaderToggleProps {
  className?: string;
  panelTitle: string;
  titleDataCy?: string;
  titleSectionRight?: JSXElement;
  rightActions?: JSXElement | JSXElement[];
  toggleContent?: JSXElement;
  showToggleContent?: boolean;
  content?: JSXElement;
  subHeaderContent?: JSXElement;
  contentRef?(element: HTMLDivElement): void;
}

export const PanelLayoutWithHeaderToggle = (
  props: PanelLayoutWithHeaderToggleProps
): JSX.Element => {
  const titleSectionRight = (): JSXElement => {
    return props.showToggleContent ? (
      props.toggleContent
    ) : (
      <>{props.titleSectionRight}</>
    );
  };

  return (
    <PanelLayout
      className={props.className}
      panelTitle={props.showToggleContent ? '' : props.panelTitle}
      titleDataCy={props.titleDataCy}
      titleSectionRight={titleSectionRight()}
      rightActions={props.showToggleContent ? '' : props.rightActions}
      content={props.content}
      contentRef={props.contentRef}
      subHeaderContent={props.showToggleContent ? null : props.subHeaderContent}
    />
  );
};
